import { setCurrentView } from "core/utils";
import { DressingRuleListViewStore } from "application/dressing-rule/stores";
import { DressingRuleListTemplate } from "themes/application/dressing-rule/pages";
import { observer } from "mobx-react";
import React from "react";

@setCurrentView(rootStore => new DressingRuleListViewStore(rootStore), "dressingRuleListViewStore")
@observer
class DressingRuleList extends React.Component {
    render() {
        return <DressingRuleListTemplate {...this.props}/>
    }
}

export default DressingRuleList;